var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIconCrircleBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13269",
    "data-name": "Group 13269",
    transform: "translate(-1479 -242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    transform: "translate(1479 242)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44583",
    "data-name": "Path 44583",
    d: "M30.045,18.616H18.911V30.045H11.134V18.616H0V11.429H11.134V0h7.776V11.429H30.045Z",
    transform: "translate(1504.778 246.815) rotate(45)",
    fill: "#111",
    stroke: "#fff",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconCrircleBlack);
export default __webpack_public_path__ + "static/media/cancel_icon_crircle_black.019acbe4b09e12164308342fdf4e8474.svg";
export { ForwardRef as ReactComponent };